import { configureNextServerRequest } from "@repo/next-utils/next-server-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { prependUrlWithHttps } from "@repo/utils/prepend-url-with-https";

import { BrowseSearchV2 } from "./types";

export type SearchParams = {
  requestInstance: ReturnType<typeof configureNextServerRequest>;
  q: string;
  keyStoreDataversion: string;
  shop: string;
  country: string;
  lang: string;
  currency: string;
  store: string;
  sizeSchema: string;
  includeGroups?: string;
  "tst-search-recs"?: string;
  "tst-search-reciprocalfiltering"?: string;
  "tst-search-campaigns"?: string;
  "tst-search-sponsored-products"?: string;
  "tst-search-advertisements"?: string;
  customerGuid?: string;
  rowLength?: number;
  "key-search-campaign"?: string;
  "key-search-mvtid"?: string;
  region?: string;
  limit?: number;
  excludeFacets?: string;
  advertisementsPartnerId?: string;
  advertisementsOptInConsent?: string;
  advertisementsVisitorId?: string;
  includeNonPurchasableTypes?: string[];
  customerLoyaltyTier?: string;
  channel?: string;
};

export const getSearch = async (props: SearchParams) => {
  const { requestInstance, ...searchParams } = props;
  const url = getApiUrl({
    path: `/product/search/v2/`,
    searchParams,
  });

  try {
    const { data } = await requestInstance.get<BrowseSearchV2>(url, undefined, {
      requestType: "SEARCH_API",
    });

    const transformedProducts = data.products.map((product) => ({
      ...product,
      imageUrl: prependUrlWithHttps(product.imageUrl),
      additionalImageUrls:
        product.additionalImageUrls?.map(prependUrlWithHttps) ?? [],
    }));

    return { ...data, products: transformedProducts };
  } catch (error) {
    console.error(error);
    throw error;
  }
};
